import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { generateSignature } from 'helper/signature';

import { getPreselectedExercisePreviewImage, getSelectedExercisePreviewImage } from 'store/exercises';
import { RootStateType as ExercisesRootStateType } from 'store/exercises';
import { actionCreators as exercisesAC } from 'store/exercises';
import { getCurrentDayNumber, getLastDayOfProgram, getStartDate } from 'store/programDays';
import { actionCreators as itemAC, getMenuTypeLabel } from 'store/programItems';

import { getLevel, getPoints, RootStateType as ProfileStateType } from 'store/profile';
import {
	getCardImage,
	getCategoryIcon,
	getDisableRetailerContext,
	getExternalId,
	getExternalIdById,
	getIsDone,
	getIsFavorite,
	getIsMigustoRecipe,
	getIsPostponed,
	getLogo,
	getProductId,
	getSelectedExerciseId,
	getThirdPartyLogo,
	getTitle,
	getType,
	getValidRange,
} from 'store/programItems';
import { RootStateType as ProgramItemsRootStateType } from 'store/programItems';
import { RootStateType as ProgramsRootStateType } from 'store/programs';
import { getNumberOfDays } from 'store/programs';
import { getActiveProgramExternalId, getActiveProgramId, getActiveProgramName } from 'store/programs';
import { RootStateType as TransientPoolRootStateType } from 'store/transientPoolState';
import { actionCreators as transientPoolAC, getDayRef, getProgramItemRef } from 'store/transientPoolState';
import { actionCreators as tutorialActionCreators } from 'store/tutorial';

import Card from 'components/molecules/Card';
import { CardProps } from 'components/molecules/Card';

import withFavorite from 'components/hoc/Cards/withFavorite';
import withHandleComplete from 'components/hoc/Cards/withHandleComplete';
import withHandleProduct from 'components/hoc/Cards/withHandleProduct';
import withTracker from 'components/hoc/Cards/withTracker';
import withUiState from 'components/hoc/Cards/withUiState';
import withLayout from 'components/hoc/withLayout';

type OwnPropsType = {
	id: string & number;
};

type RootStateType = ProgramItemsRootStateType &
	ExercisesRootStateType &
	ProgramsRootStateType &
	TransientPoolRootStateType &
	ProfileStateType;

const mapStateToProps = (state: RootStateType, ownProps: OwnPropsType): CardProps => {
	const selectedExerciseId = getSelectedExerciseId(state, ownProps.id);
	const externalId = getExternalId(state, ownProps.id);
	const programItemExternalId = getExternalIdById(state, ownProps.id);
	const contentTypeExternalId = getExternalId(state, ownProps.id);
	const title = getTitle(state, ownProps.id);
	const type = getType(state, ownProps.id);
	const logo = getLogo(state, ownProps.id);
	const numberOfDays = getNumberOfDays(state);
	const points = getPoints(state);
	const level = getLevel(state);
	const favorite = getIsFavorite(state, ownProps.id);
	const thirdPartyLogo = getThirdPartyLogo(state, ownProps.id);
	const productId = getProductId(state, ownProps.id);
	const validRange = getValidRange(state, ownProps.id);
	const isMigustoRecipe = getIsMigustoRecipe(state, ownProps.id);
	const categoryIcon = getCategoryIcon(state, ownProps.id);
	const uiState = getIsDone(state, ownProps.id) ? 'folded' : 'feed';
	const previewImage = getCardImage(state, ownProps.id);
	const isPostponed = getIsPostponed(state, ownProps.id);
	const customWorkoutPreviewImage = getSelectedExercisePreviewImage(state, selectedExerciseId);
	const preselectedCustomWorkoutPreviewImage = getPreselectedExercisePreviewImage(
		state,
		selectedExerciseId,
		ownProps.id
	);
	const activeProgramId = getActiveProgramId(state);
	const activeProgramExternalId = getActiveProgramExternalId(state);
	const activeProgramName = getActiveProgramName();
	const disableRetailerContext = getDisableRetailerContext(state, ownProps.id);
	const dayRef = getDayRef(state);
	const programItemRef = getProgramItemRef(state);
	const currentDayNumber = getCurrentDayNumber(state);
	const startDate = getStartDate(state);
	const endDate = getLastDayOfProgram(state);
	const menuTypeLabel = getMenuTypeLabel(state, ownProps.id);

	// const portionSelection = getPortionSelection(state, ownProps.id);
	const idSignature = `${ownProps.id}-${externalId}-${contentTypeExternalId}-`;
	const signature =
		idSignature +
		generateSignature(
			dayRef,
			state,
			title,
			type,
			logo,
			isPostponed,
			favorite,
			thirdPartyLogo,
			productId,
			disableRetailerContext,
			validRange,
			isMigustoRecipe,
			uiState,
			categoryIcon,
			previewImage,
			customWorkoutPreviewImage,
			preselectedCustomWorkoutPreviewImage,
			activeProgramId,
			activeProgramExternalId,
			activeProgramName
		);

	return {
		externalId,
		isPostponed,
		contentTypeExternalId,
		programItemExternalId,
		id: ownProps.id, // FIXME: number, not string!
		dayRef,
		programItemRef,
		signature,
		disableRetailerContext,
		title,
		numberOfDays,
		points,
		level,
		type,
		logo,
		favorite,
		thirdPartyLogo,
		productId,
		validRange,
		isMigustoRecipe,
		categoryIcon,
		state: uiState,
		previewImage,
		customWorkoutPreviewImage,
		preselectedCustomWorkoutPreviewImage,
		activeProgramId,
		activeProgramExternalId,
		activeProgramName,
		currentDayNumber,
		startDate,
		endDate,
		menuTypeLabel,
	} as any;
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...itemAC,
			...{
				doPreselectExercise: exercisesAC.doPreselectExercise,
				doTriggerTutorial: tutorialActionCreators.doTriggerTutorial,
				doSetProgramItemRef: transientPoolAC.doSetProgramItemRef,
			},
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTracker(withLayout(withUiState(withHandleComplete(withHandleProduct(withFavorite(Card)))))));
